import { memo } from "react"
import { HStack, Input, Flex, Container } from "@chakra-ui/react"
import { Box, Circle, Float, IconButton, Text, Heading, Image } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle, LuHouse, LuMenu } from "react-icons/lu"
import { useCart } from "contexts/cart"
import { useNavigate } from "react-router"
import { useApp } from "contexts/app";
import ProductService from "@/services/product"
import { useStore } from "contexts/store";

const Header = () => {
    let navigate = useNavigate();
    const { cart } = useCart();
    const { showProductSearch, setShowProductSearch, pageTitle, showMenu, setShowMenu } = useApp();
    const { store } = useStore();
    return (

        <Flex bg="bg.muted" style={{ padding: 8 }} direction={"column"}>
            <div style={{ justifyContent: "center", display: "flex" }}>
                <div style={{ width: 135 }}>
                    {store.web.image?.md_url &&
                        <img
                            style={{ width: 135, height: 135, borderRadius: "50%", objectFit: "contain" }}
                            src={store.web.image?.md_url}
                        >
                        </img>

                        // <Image
                        //     src={store.web.image?.md_url}

                        //     borderRadius="full"
                        //     fit="contain"

                        // />
                    }

                </div>
              
            </div>
              <div style={{ justifyContent: "center", display: "flex" }}>
                  <p>
                    <b>{store.web.title}</b>
                </p>
            </div>
            <div style={{ marginTop: 8, display: "flex", gap: 16 }}>
                    <p>{store.web.description}</p>

            </div>
            <div style={{ paddingBottom: 75, marginTop: 16 }}>
                <p>
                    <b>Địa chỉ:</b> {store.web.address}

                </p>


                <p>
                    <b>Copyright :</b>   <a href="https://sipro.app" target="_blank">Sỉ Pro</a>
                </p>




            </div>
        </Flex>



    )
}

export default memo(Header)